import "./images"
import "../stylesheets/global.scss"

import "bootstrap-sass/assets/javascripts/bootstrap"
import "moment"
import "bootstrap-fileinput"
import "bootstrap-fileinput/js/locales/it"
import "bootstrap-fileinput/themes/gly/theme"
import Rails from "@rails/ujs"
// Turbo si auto-avvia all'import; la variabile default non serve (e Turbo 8
// non espone più un default export)
import "@hotwired/turbo"
import "channels"

import MyApp from "./my_app"

Rails.start()

MyApp.start()
if ( window ) {
  window.MyApp = MyApp;
}
